import { CurrentPageState } from './currentPageSlice';

export const initialState: CurrentPageState = {
  name: '',
};
